import { useCallback } from "react";
import { Popconfirm, Button, message } from "antd";
import { message as messageService } from "@/services";
import { useAuthContext } from "@/components/auth/AuthProvider";

function MessageWaitButton({ type, size = "default", messageId, callback }) {
  const auth = useAuthContext();
  const confirmHandler = useCallback(() => {
    messageService.waitMessage(messageId, {}, auth.token).then(() => {
      message.success("操作成功");
      callback(Date.now());
    });
  }, [messageId, auth, callback]);
  return (
    <Popconfirm
      title="请确认?"
      onConfirm={confirmHandler}
      okText="是"
      cancelText="否"
    >
      <Button type={type} size={size}>
        待处理
      </Button>
    </Popconfirm>
  );
}

export default MessageWaitButton;
